import initProjectPipelinesChartsApp from '~/projects/pipelines/charts/index';

document.addEventListener('DOMContentLoaded', initProjectPipelinesChartsApp);
